import { render, staticRenderFns } from "./page-noReturnVisit-view.vue?vue&type=template&id=53cbb610&scoped=true&"
import script from "./page-noReturnVisit-view.vue?vue&type=script&lang=js&"
export * from "./page-noReturnVisit-view.vue?vue&type=script&lang=js&"
import style0 from "./page-noReturnVisit-view.vue?vue&type=style&index=0&id=53cbb610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cbb610",
  null
  
)

component.options.__file = "page-noReturnVisit-view.vue"
export default component.exports